module.exports = __webpack_public_path__ + "static/media/star.b6e36361.svg";